import { useQuery } from 'react-query';

import { DutyHourType } from '../types';

import { getDutyHourTypesTableDataConverter } from '../utils/getDutyHourTypesTableDataConverter';

import { getDutyHourTypes } from 'RestAPIs/dutyHourTypes';

export const useGetDutyHourTypesTableData = () =>
  useQuery<DutyHourType[]>(
    ['dutyHourTypes', 'list'],
    async () =>
      await getDutyHourTypes().then(getDutyHourTypesTableDataConverter)
  );
